import { action } from '@ember/object';
import GeneralButtonsButtonsPreviousNextSmall from 'lumen/components/general/buttons/buttons-previous-next-small';
import GeneralDropdownsOtaDropdown from 'lumen/components/general/dropdowns/ota-dropdown';
import { HISTORICAL_POINTS_AMOUNT } from 'lumen/utils/constants/pi-constant-values';

export default class GeneralDatepickersPickerPeriod extends GeneralDropdownsOtaDropdown {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get dropdownClass() {
    return this.args.dropdownClass ?? '.period-selection-dropdown';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get period() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.period ?? HISTORICAL_POINTS_AMOUNT - 1;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get periodType() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.periodType ?? 'day';
  }

  @action
  movePeriodNext(): void {
    // @ts-expect-error: Incorrect type
    if (!this.args.endReached) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.periodChanged(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        this.args.historicalExtractDateMoment.add(this.period, this.periodType),
      );
    }
  }

  @action
  movePeriodPrevious(): void {
    // @ts-expect-error: Incorrect type
    if (!this.args.beginReached) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.periodChanged(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        this.args.historicalExtractDateMoment.subtract(
          this.period,
          this.periodType,
        ),
      );
    }
  }

  <template>
    <GeneralButtonsButtonsPreviousNextSmall
      {{! @glint-expect-error: Incorrect type }}
      @beginReached={{@beginReached}}
      {{! @glint-expect-error: Incorrect type }}
      @endReached={{@endReached}}
      @nextClicked={{this.movePeriodNext}}
      @previousClicked={{this.movePeriodPrevious}}
    />
  </template>
}
